import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'helpers/translateHelper';
import colors from 'theme/_colors.scss';
import './style.scss';
import { maxAnomalyLevel } from '../CoolingAnomalyChart/constants';
import { DEFAULT_PRECISION } from 'helpers/constants';

const formatTimestamp = (ts) => {
    const d = new Date(ts);
    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};

const getMarkerElement = (symbol, color) => {
    const base = { flexShrink: 0, display: 'inline-block', verticalAlign: 'middle' };
    switch (symbol) {
        case 'square':
            return <span style={{ ...base, width: '8px', height: '8px', backgroundColor: color }} />;
        case 'diamond':
            return <span style={{ ...base, width: '7px', height: '7px', backgroundColor: color, transform: 'rotate(45deg)' }} />;
        case 'triangle':
            return <span style={{ ...base, width: 0, height: 0, borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderBottom: `9px solid ${color}` }} />;
        case 'triangle-down':
            return <span style={{ ...base, width: 0, height: 0, borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderTop: `9px solid ${color}` }} />;
        default: // 'circle' or unknown
            return <span className='t-bullet' style={{ backgroundColor: color }} />;
    }
};

const ACS1000CoolingTooltip = ({ points, timeStamp }) => {
    if (!points?.length) { return null; }
    const anomalyRows = points.filter(p => p?.point?.isAnomalousPoint === true);

    return (
        <div className='acs1000-cooling-tooltip'>
            <span className='t-header'>{formatTimestamp(timeStamp)}</span>

            {anomalyRows?.length > 0 &&
                <div className='t-anomaly-section'>
                    {anomalyRows?.map((point) => {
                        const { custom = {} } = point?.series?.options || {};
                        const { description = '', maxAnomalyLevel: maxLevel = maxAnomalyLevel } = custom;
                        const pointAnomalyLevel = point?.point?.anomalyLevel ?? 0;
                        const rowKey = `anomaly-${point?.series?.options?.id ?? description}`;
                        return (
                            <div key={rowKey} className='t-anomaly-row'>
                                <span className='t-bullet' style={{ backgroundColor: colors.orangePeel }} />
                                <span>
                                    {`${translate('ABB.Powertrain.Frontend.conditionIndicesOverviewAnomalyColumnTitle')}: ${description} (${pointAnomalyLevel}/${maxLevel})`}
                                </span>
                            </div>
                        );
                    })}
                </div>
            }

            {points?.map((point) => {
                const { custom = {} } = point?.series?.options || {};
                const { description = '', unitLabel = '', markerSymbol = 'circle' } = custom;
                const seriesColor = point?.series?.color || colors.black;
                const value = point?.y !== null && point?.y !== undefined ? Number(point.y).toFixed(DEFAULT_PRECISION) : '-';
                const unitSuffix = unitLabel ? ` ${unitLabel}` : '';
                const rowKey = `value-${point?.series?.options?.id ?? description}`;
                return (
                    <div key={rowKey} className='t-value-row'>
                        {getMarkerElement(markerSymbol, seriesColor)}
                        <span>{`${description}: ${value}${unitSuffix}`}</span>
                    </div>
                );
            })}
        </div>
    );
};

ACS1000CoolingTooltip.propTypes = {
    points: PropTypes.array,
    timeStamp: PropTypes.number,
};

export default ACS1000CoolingTooltip;
